import { useQuery } from '@apollo/client';

import { TaxForecastPeriodQueryDocument } from './taxForecastPeriod.gql';

export const useTaxForecastPeriod = (
  taxForecastPeriodId: string | undefined,
) => {
  const { data, ...hook } = useQuery(TaxForecastPeriodQueryDocument, {
    skip: !taxForecastPeriodId,
    variables: { taxForecastPeriodId: taxForecastPeriodId ?? '' },
  });

  return {
    ...hook,
    taxForecastPeriod: data?.taxForecastPeriod,
    taxForecastRates: data?.taxForecastPeriod.computedTaxForecasts,
  };
};

export type TaxForecastRate = NonNullable<
  Awaited<ReturnType<typeof useTaxForecastPeriod>>['taxForecastRates']
>[number];
